import React, { useState } from 'react';
import { X } from 'lucide-react';
import { collection, addDoc } from "firebase/firestore";

const modalOverlayStyle = { position: 'fixed', top:0, left:0, right:0, bottom:0, backgroundColor: 'rgba(0,0,0,0.5)', display:'flex', justifyContent:'center', alignItems:'center', zIndex: 1000 };
const modalContentStyle = { backgroundColor: 'white', width: '600px', maxWidth:'95%', borderRadius: '8px', padding: '20px', display:'flex', flexDirection:'column', position: 'relative' };
const rowStyle = { display: 'flex', gap: '15px', marginBottom: '15px' };
const labelStyle = { display: 'block', fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase' };
const inputStyle = { width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box' };
const btnPrimaryStyle = { backgroundColor: '#2563eb', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' };

export const NewWarehouseModal = ({ show, onClose, onSave, db }) => {
  const [newWh, setNewWh] = useState({
    name: '',
    code: '',
    contactPerson: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    status: 'Active'
  });

  if (!show) return null;

  const handleChange = (e) => setNewWh({ ...newWh, [e.target.name]: e.target.value });

  const saveWarehouse = async () => {
    if (!newWh.name || !newWh.code) return alert("Warehouse Name and Code are required.");
    
    try {
      const docRef = await addDoc(collection(db, "warehouses"), {
        ...newWh,
        createdAt: new Date().toISOString()
      });
      const savedWh = { id: docRef.id, ...newWh };
      onSave(savedWh);
      onClose();
    } catch (e) {
      console.error("Error saving warehouse:", e);
      alert("Error saving warehouse");
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '15px', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>New Warehouse</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer' }}><X size={24} /></button>
        </div>

        <div style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: '10px' }}>
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Warehouse Name *</label><input name="name" value={newWh.name} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>Warehouse Code *</label><input name="code" value={newWh.code} onChange={handleChange} style={inputStyle} /></div>
          </div>
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Contact Person</label><input name="contactPerson" value={newWh.contactPerson} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>Phone Number</label><input name="phone" value={newWh.phone} onChange={handleChange} style={inputStyle} /></div>
          </div>
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Email Address</label><input name="email" value={newWh.email} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Status</label>
              <select name="status" value={newWh.status} onChange={handleChange} style={inputStyle}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
          <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Address</label><textarea name="address" value={newWh.address} onChange={handleChange} style={{ ...inputStyle, minHeight: '60px' }} /></div>
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>City</label><input name="city" value={newWh.city} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>State</label><input name="state" value={newWh.state} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>PIN Code</label><input name="pincode" value={newWh.pincode} onChange={handleChange} style={inputStyle} /></div>
          </div>
        </div>
        
        <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 20, paddingTop: 15, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
           <button onClick={onClose} style={{ padding: '8px 15px', border: '1px solid #d1d5db', background: 'white', borderRadius: 5, cursor:'pointer' }}>Cancel</button>
           <button onClick={saveWarehouse} style={btnPrimaryStyle}>Save Warehouse</button>
        </div>
      </div>
    </div>
  );
};
